import SavedReportList, { SavedReportListProps } from 'common/pages/saved-report/SavedReportList.tsx'

export const SavedReportListAgency = (props: SavedReportListProps) => <SavedReportList {...props} />
